// ========================================
// Widget: RRHH — Pendientes («Tienes N cosas pendientes»)
// Lo que espera a RRHH hoy: vacaciones y permisos por aprobar, nóminas del mes
// anterior que faltan, avisos a la asesoría de altas sin notificar y justificantes
// sin revisar. Cada tarjeta lleva a donde se resuelve.
// ========================================

window.DashboardWidgets = window.DashboardWidgets || {};
window.DashboardWidgets.rrhh = window.DashboardWidgets.rrhh || {};

window.DashboardWidgets.rrhh.pendientes = function(ctx) {
    const { leaves, payrollDue, advisoryPending = [], justificantesNew = 0 } = ctx;
    const pendingLeaves = leaves && leaves.pending ? leaves.pending.filter(l => !l.own) : null;
    const names = list => list.slice(0, 2).join(' y ') + (list.length > 2 ? ` y ${list.length - 2} más` : '');
    const items = [
        { n: pendingLeaves ? pendingLeaves.length : '…', title: 'Vacaciones y permisos', go: 'profesores',
          sub: pendingLeaves ? (pendingLeaves.length ? 'Solicitudes esperando tu respuesta' : 'Ninguna solicitud pendiente') : 'Cargando…',
          target: 'permisos-aprobar' },
        { n: payrollDue.missing.length, title: `Nóminas de ${payrollDue.monthName.toLowerCase()}`, go: 'nominas',
          sub: payrollDue.missing.length ? `Faltan ${names(payrollDue.missing)}` : 'Están todas subidas' },
        { n: advisoryPending.length, title: 'Avisos a la asesoría', go: advisoryPending.length === 1 ? `profesor/${advisoryPending[0].id}` : 'profesores',
          sub: advisoryPending.length ? `Altas sin notificar: ${names(advisoryPending.map(p => p.name))}` : 'Todas las altas notificadas' },
        { n: justificantesNew, title: 'Justificantes nuevos', go: 'justificantes',
          sub: justificantesNew ? 'Sin revisar todavía' : 'Todos revisados' }
    ];
    const total = items.reduce((s, item) => s + (typeof item.n === 'number' && item.n > 0 ? 1 : 0), 0);
    const inner = `
        <div class="rp-card-head">
            <h2 class="rp-card-title">${total ? `Tienes ${total} ${total === 1 ? 'cosa pendiente' : 'cosas pendientes'}` : 'Todo al día'}</h2>
            <span class="rp-muted">Pulsa una para ir directamente</span>
        </div>
        <div class="rp-todo-grid">
            ${items.map(item => `
                <button type="button" class="rp-todo-item ${item.n === 0 ? 'is-clear' : ''}" ${UIEvents.attr("click", function(event,captured){
                    if (captured[1]) { const card = document.getElementById('widget-' + captured[1]); if (card && card.style.display !== 'none') { card.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; } }
                    App.navigate(String(captured[0]));
                }, [item.go, item.target || ''])}>
                    <span class="rp-todo-n">${item.n}</span>
                    <span class="rp-todo-title">${Utils.sanitizeHTML(item.title)}</span>
                    <span class="rp-todo-sub">${Utils.sanitizeHTML(item.sub)}</span>
                </button>`).join('')}
        </div>`;
    return window.DashboardWidgets.rrhh.card(ctx, inner, { className: 'rp-todo' });
};
